<template>
  <!-- 任务列表 -->
  <div
    class="paginations"
    :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
  >
    <div class="table-search-box">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 防止输入框回车刷新页面 -->
        <el-form-item label="" v-show="false">
          <el-input></el-input>
        </el-form-item>
        <el-form-item label="资源库：">
          <el-input
            size="small"
            v-model="searchData.zykname"
            placeholder="请输入资源库"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型：">
          <el-select
            size="small"
            v-model="searchData.taskType"
            placeholder="请选择"
            filterable
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in dropDown.taskTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台：">
          <el-select
            size="small"
            v-model="searchData.platformid"
            placeholder="请选择"
            filterable
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in dropDown.platformList"
              :key="index"
              :label="item.platformname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送状态：">
          <el-select
            size="small"
            v-model="searchData.status"
            placeholder="请选择"
            filterable
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in dropDown.statusList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search('1')"></i>
            <i class="pointer el-icon-refresh-left" @click="reset"></i>
          </div>
        </el-form-item>
        <el-form-item class="addition position">
          <el-button @click="add()">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_box">
      <el-table :data="tableObj.list" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="taskContent"
          label="任务概述"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="taskType"
          label="任务类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="level"
          label="级别"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="platformName"
          label="平台名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="截止日期" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.deadline ? scope.row.deadline.substring(0, 10) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预计推送日期" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.startTime ? scope.row.startTime.substring(0, 10) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否推送" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1 && !scope.row.isOverdue"
              >未推送</span
            >
            <span v-if="scope.row.status == 2" style="color: #1aecef"
              >已推送</span
            >
            <el-tooltip
              v-if="scope.row.isOverdue"
              class="item"
              effect="dark"
              content="已逾期"
              placement="top-start"
            >
              <el-badge is-dot class="item">未推送</el-badge>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="创建日期" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.createTime ? scope.row.createTime.substring(0, 10) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <i
              class="icona icon-edit"
              title="编辑"
              @click="edit(scope.row)"
            ></i>
            <i
              class="icona icon-delete"
              title="删除"
              @click="deletes(scope.row.id)"
            ></i>
            <i
              class="icona icon-download"
              title="下载"
              @click="download(scope.row.fileid)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber
        :paginations="7"
        :pageNum="searchData.pageDto.pageNum"
        :pageSize="searchData.pageDto.pageSize"
        :total="tableObj.total"
        :jumpTo="tableObj.jumpTo"
        @currentChange="search"
      ></pageNumber>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form
        ref="uploadBox"
        :model="uploadBox.data"
        :rules="uploadBox.rules"
        label-width="130px"
      >
        <el-form-item label="截止日期：" prop="deadline" required>
          <el-date-picker
            size="small"
            type="date"
            placeholder="选择日期"
            v-model="uploadBox.data.deadline"
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
            popper-class="dateClass"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="任务类型：" prop="taskType" required>
          <el-select
            size="small"
            v-model="uploadBox.data.taskType"
            placeholder="请选择"
            filterable
            style="width: 100%"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in dropDown.taskTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="级别：" prop="level" required>
          <el-select
            size="small"
            v-model="uploadBox.data.level"
            placeholder="请选择"
            filterable
            style="width: 100%"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in dropDown.levelList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务概述：" prop="taskContent" required>
          <el-input
            size="small"
            type="textarea"
            v-model="uploadBox.data.taskContent"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="type" required>
          <el-radio-group v-model="uploadBox.data.type">
            <el-radio label="1">平台</el-radio>
            <el-radio label="2">资源库</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="平台："
          prop="platform"
          v-if="uploadBox.data.type == 1"
        >
          <el-select
            size="small"
            v-model="uploadBox.data.platform"
            placeholder="请选择"
            style="width: 100%"
            filterable
            :popper-append-to-body="false"
            multiple
          >
            <el-option
              v-for="(item, index) in dropDown.platformList"
              :key="index"
              :label="item.platformname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="资源库ID："
          prop="zykids"
          v-if="uploadBox.data.type == 2"
        >
          <el-input
            size="small"
            type="textarea"
            v-model="uploadBox.data.zykids"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传推送需求：" prop="file">
          <el-upload
            class="avatar-uploader"
            :action="$apiurls.task_uploadFile"
            :headers="headers"
            :limit="1"
            :file-list="uploadBox.file"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeReportUpload"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      headers: { lrmv2token: sessionStorage.getItem("lrmv2token") },
      searchData: {
        zykname: "",
        taskType: "",
        platformid: "",
        status: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },

      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },

      uploadBox: {
        show: false,
        title: "编辑账号",
        file: [],
        data: {
          id: null,
          deadline: "",
          taskType: "",
          level: "",
          taskContent: "",
          type: "1",
          platformid: "",
          platform: [],
          zykids: "",
          fileid: "",
          status: 1,
        },
        rules: {
          deadline: [
            { required: true, message: "截止日期不能为空！", trigger: "blur" },
          ],
          taskType: [
            { required: true, message: "请选择任务类型！", trigger: "change" },
          ],
          taskContent: [
            { required: true, message: "任务概述不能为空！", trigger: "blur" },
          ],
          type: [
            { required: true, message: "类型不能为空！", trigger: "blur" },
          ],
        },
      },

      dropDown: {
        //下拉框
        taskTypeList: [
          { id: 1, name: "任务类型1" },
          { id: 2, name: "任务类型2" },
          { id: 3, name: "任务类型3" },
        ],
        platformList: [],
        statusList: [
          { id: 1, name: "未推送" },
          { id: 2, name: "已推送" },
        ],
        levelList: [
          { id: 1, name: "级别1" },
          { id: 2, name: "级别2" },
          { id: 3, name: "级别3" },
          { id: 4, name: "级别4" },
        ],
      },
    };
  },
  created() {
    this.platformsDom();
    this.search();
  },
  methods: {
    // 获取所有平台下拉选项
    platformsDom() {
      this.$axios
        .post(this.$apiurls.task_getAllPlatforms, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.dropDown.platformList = res.data;
          }
        });
    },

    // 查询表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1;
      this.tableObj.jumpTo = type ? type : 1;
      this.$axios
        .post(
          this.$apiurls.task_getLv2PlatformTaskInfoEntityList,
          this.searchData,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.list.length; i++) {
              var data1 = new Date(res.data.list[i].deadline);
              var data2 = new Date();
              if (
                data1.getTime() < data2.getTime() &&
                res.data.list[i].status == 1
              ) {
                res.data.list[i].isOverdue = true;
              } else if (
                data1.getTime() > data2.getTime() &&
                res.data.list[i].isOverdue
              ) {
                res.data.list[i].isOverdue = false;
              }
            }
            if (type) {
              this.$message({
                message: "查询成功！",
                type: "success",
              });
            }
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.zykname = "";
      this.searchData.taskType = "";
      this.searchData.platformid = "";
      this.searchData.status = "";
      this.search();
    },
    // 编辑
    edit(row) {
      this.uploadBox.title = "编辑";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      this.uploadBox.data.id = row.id;
      this.uploadBox.data.deadline = row.deadline;
      this.uploadBox.data.taskType = row.taskType;
      this.uploadBox.data.level = row.level;
      this.uploadBox.data.taskContent = row.taskContent;
      this.uploadBox.data.platformid = row.platformid;
      this.uploadBox.data.platform = [row.platformid];
      this.uploadBox.data.zykids = row.zykids;
      this.uploadBox.data.fileid = row.fileid;
      this.uploadBox.data.type = row.type ? String(row.type) : "0";
      this.uploadBox.data.status = row.status;
      this.uploadBox.file = [];
      if (row.file) {
        this.uploadBox.file.push({
          name: row.file.originalName,
          url: row.file.filePath,
        });
      }
    },
    // 删除
    deletes(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(this.$apiurls.task_deleteLv2PlatformTaskInfo, id, {
              loading: false,
            })
            .then((res) => {
              if (res) {
                if (res.data) {
                  this.$message({
                    message: "删除成功！",
                    type: "success",
                  });
                } else {
                  this.$message.error("删除失败！");
                }
                this.search();
              }
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.$store.commit("modifyVague", false);
        });
    },

    // 下载
    download(fileid) {
      if (fileid) {
        window.open(
          `${this.$apiurls.task_downloadLv2PlatformTaskFileInfo}?fileid=${fileid}`
        );
      } else {
        this.$message.error("下载失败，没有上传文件");
      }
    },

    // 新增
    add() {
      this.uploadBox.title = "新增";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      this.uploadBox.data.id = null;
      this.uploadBox.data.deadline = "";
      this.uploadBox.data.taskType = "";
      this.uploadBox.data.level = "";
      this.uploadBox.data.taskContent = "";
      this.uploadBox.data.type = "1";
      this.uploadBox.data.platform = [];
      this.uploadBox.data.platformid = "";
      this.uploadBox.data.zykids = "";
      this.uploadBox.file = [];
      this.uploadBox.data.fileid = "";
      this.uploadBox.data.status = 1;
    },
    // 关闭弹窗
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
    },
    // 确认新增
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.uploadBox.data.platformid =
            this.uploadBox.data.platform.toString();
          this.$axios
            .post(
              this.$apiurls.task_saveOrUpdateLv2PlatformTaskInfo,
              this.uploadBox.data,
              {
                loading: false,
              }
            )
            .then((res) => {
              if (res && res.data) {
                this.$message({
                  message: this.uploadBox.data.id ? "编辑成功" : "添加成功",
                  type: "success",
                });
              } else {
                this.$message.error(
                  this.uploadBox.data.id ? "编辑失败" : "添加失败"
                );
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
              this.search();
            });
        }
      });
    },
    // 文件上传成功
    handleAvatarSuccess(res, file) {
      this.uploadBox.data.fileid = res.data.id;
      this.uploadBox.file.push({
        name: res.data.originalName,
        url: res.data.filePath,
      });
    },
    // 校验上传文件
    beforeReportUpload: function (file) {
      console.log("上传文件", file);
      // var isFile = file.type === "application/pdf";
      // if (!isFile) {
      //   this.$message.error('只能上传pdf文件');
      // }
      // return isFile;
    },

    // 移除文件
    handleRemove(file, fileList) {
      this.uploadBox.data.fileid = "";
      this.uploadBox.file = fileList;
    },
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
  },
};
</script>


<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
  overflow-y: auto;
}
.el-from {
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-upload-list__item-name {
  color: #409eff;
}
</style>
